import { normalizeLegacyPermissionParents } from "../consts/management/users/users";

export const getAllowedUserPermissions = ({
    permissions,
    permissionRouteAliases = {},
    permissionCatalog = [],
    isAdmin = false,
}) => {
    const allowedChildIds = new Set();
    const allowedParentIds = new Set();
    const childIdToAccess = new Map();
    (normalizeLegacyPermissionParents(permissions) || []).forEach((permissionGroup) => {
        const [parentKey, children] = Object.entries(permissionGroup || {})[0] || [];
        
        (children || []).forEach((childPermission) => {
          const [childKey, access] = Object.entries(childPermission || {})[0] || [];
          
          if (access === "edit" || access === "view") {
            allowedChildIds.add(childKey);
            allowedParentIds.add(parentKey);
            const prev = childIdToAccess.get(childKey);
            // Prefer 'edit' over 'view' if both appear
            if (!prev || access === 'edit') {
              childIdToAccess.set(childKey, access);
            }
            const routeId = permissionRouteAliases[childKey];
            if (routeId) {
              allowedChildIds.add(routeId);
              const routePrev = childIdToAccess.get(routeId);
              if (!routePrev || access === 'edit') {
                childIdToAccess.set(routeId, access);
              }
            }
          }
        });
    });

    if (isAdmin) {
        permissionCatalog.forEach(({ permissionId, routePermissionId, parentId }) => {
            allowedChildIds.add(permissionId);
            allowedParentIds.add(parentId);
            childIdToAccess.set(permissionId, 'edit');
            if (routePermissionId) {
                allowedChildIds.add(routePermissionId);
                childIdToAccess.set(routePermissionId, 'edit');
            }
        });
    }

    return {
        allowedChildIds,
        allowedParentIds,
        childIdToAccess,
    }
}
